import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import SearchSideBar from "../components/search/searchSideBar";
import Table from "../components/table/Table";
import Navbar from "../components/ui/navbar";
import Footer from "../components/ui/Footer";
import useTableStore from "../store/useTabStore";

const TextSearch: React.FC = () => {
  const { setFilters, resetFilter } = useTableStore();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const filterParam = searchParams.get("filter");
    if (filterParam) {
      try {
        const filters = JSON.parse(decodeURIComponent(filterParam));

        if (Object.keys(filters).length > 0) {
          setFilters(filters);
        }
      } catch (error) {
        console.error("Filter parameter parsing failed:", error);
      }
    }

    return () => {
      resetFilter();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="relative flex-shrink-0 w-full py-8 border-b border-1">
        <Navbar />
      </div>
      <div className="flex flex-1 justify-center p-2 md:p-4">
        <div className="flex-shrink-0 w-60 md:w-72 mr-4">
          <SearchSideBar />
        </div>
        <div className="flex flex-col flex-1 min-w-0">
          <div className="w-full overflow-x-auto flex-1">
            <Table />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default TextSearch;
